module.exports = __webpack_public_path__ + "static/media/result-test-sucess.a31a0f71.svg";